import * as AssociationActionTypes from 'automation-ui-associations/constants/AssociationActionTypes';
import * as crmObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
export const ActionAssociationDefaults = {
  [AssociationActionTypes.TASK]: {
    [crmObjectTypes.CONTACT_ID]: [crmObjectTypes.COMPANY_ID],
    [crmObjectTypes.COMPANY_ID]: [],
    [crmObjectTypes.TICKET_ID]: [crmObjectTypes.COMPANY_ID],
    [crmObjectTypes.QUOTE_ID]: [crmObjectTypes.DEAL_ID],
    [crmObjectTypes.DEAL_ID]: [crmObjectTypes.COMPANY_ID]
  },
  [AssociationActionTypes.CREATE_OBJECT]: {
    [crmObjectTypes.DEAL_ID]: {
      [crmObjectTypes.CONTACT_ID]: [crmObjectTypes.COMPANY_ID],
      [crmObjectTypes.COMPANY_ID]: [],
      [crmObjectTypes.TICKET_ID]: [crmObjectTypes.CONTACT_ID, crmObjectTypes.COMPANY_ID],
      [crmObjectTypes.QUOTE_ID]: [crmObjectTypes.CONTACT_ID, crmObjectTypes.COMPANY_ID],
      [crmObjectTypes.DEAL_ID]: [crmObjectTypes.CONTACT_ID, crmObjectTypes.COMPANY_ID]
    },
    [crmObjectTypes.TICKET_ID]: {
      [crmObjectTypes.CONTACT_ID]: [crmObjectTypes.COMPANY_ID],
      [crmObjectTypes.COMPANY_ID]: [],
      [crmObjectTypes.TICKET_ID]: [crmObjectTypes.CONTACT_ID, crmObjectTypes.COMPANY_ID],
      [crmObjectTypes.QUOTE_ID]: [crmObjectTypes.CONTACT_ID, crmObjectTypes.COMPANY_ID],
      [crmObjectTypes.DEAL_ID]: [crmObjectTypes.CONTACT_ID, crmObjectTypes.COMPANY_ID]
    }
  }
};